<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom>video_library</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom>{{'main.default' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" [(ngModel)]="term" matInput >
        </mat-form-field>
      </div>
      <!-- / SEARCH -->

      <button mat-raised-button
        (click)="newPolicy()"
        class="add-product-button mat-white-bg my-12 mt-sm-0">
        <span>{{'default.newPolicy' | translate}}</span>
      </button>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">
      <div class="platforms">
        <mat-form-field>
          <mat-select placeholder="{{'event.platforms' | translate}}" (selectionChange)="changePlatforms($event)"
            [value]="selectedPlatform">
            @for (plat of platforms; track plat.id) {
              <mat-option [value]="plat.id">
                {{plat.title}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <div>
          <div class="tutorial-wraper">

            @for (item of tutorials | filter:term; track item) {
              <div class="tutorial-item" (click)="show(item)">
                <section class="title">
                  <p>{{item.name}}
                    @if (write) {
                      <button (click)="editType(item, $event)"
                        style="position: absolute; right: 15px; top: 15px" mat-fab
                        [ngStyle]="{'background-color': 'green'}">
                        <mat-icon style="color: white;">edit</mat-icon>
                      </button>
                    }
                    <button (click)="openInWeb(item.id, $event)"
                      style="position: absolute; right: 15px; top: 85px" mat-fab
                      [ngStyle]="{'background-color': '#039be5'}">
                      <mat-icon style="color: white;">open_in_browser</mat-icon>
                    </button>
                    <button (click)="delete(item.id, $event)"
                      style="position: absolute; right: 15px; top: 155px" mat-fab
                      [ngStyle]="{'background-color': 'orange'}">
                      <mat-icon style="color: white;">delete</mat-icon>
                    </button>
                  </p>
                </section>
                <div [innerHTML]="item.text">
                </div>
              </div>
            }
          </div>

        </div>
      </div>
    </div>


  </div>


  <!-- / CENTER -->
</div>




